__turbopack_context__.v({
  "copyButton": "bZXHAq_copyButton",
  "copyButtonCopied": "bZXHAq_copyButtonCopied",
  "opacityGradient": "bZXHAq_opacityGradient",
  "shareDescription": "bZXHAq_shareDescription",
  "shareInput": "bZXHAq_shareInput",
  "sheetContent": "bZXHAq_sheetContent",
});
